<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-4">
        <div v-if="loading" class="jumbotron">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <table v-else class="table table-striped table-sm table-dark">
          <thead>
          <tr>
            <th scope="col">IP</th>
            <th scope="col">LOGINS</th>
            <th scope="col">CONNECTIONS</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i, index) in overviews">
            <td>{{i.ip}}</td>
            <td>{{i.logins}}</td>
            <td>{{i.connections}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-8">
        <div class="row">
          <div class="col-sm-1"></div>
          <label class="col-sm-1 col-form-label">Inicio</label>
          <div class="col-sm-4">
            <datepicker v-model="dateFrom" :bootstrap-styling="true"></datepicker>
          </div>
          <div class="col-sm-1"></div>
          <label class="col-sm-1 col-form-label">Fin</label>
          <div class="col-sm-4">
            <datepicker v-model="dateTo" :bootstrap-styling="true"></datepicker>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-sm">
            <div v-if="loading" class="jumbotron">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <table v-else class="table table-striped table-sm table-dark">
              <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">IP</th>
                <th scope="col">ACTION</th>
                <th scope="col">TIMESTAMP</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(i, index) in logs">
                <td>{{i.id}}</td>
                <td>{{i.ip}}</td>
                <td>{{i.action}}</td>
                <td>{{i.date}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  function parseDate(t){
    // Split timestamp into [ Y, M, D, h, m, s ]
    var t = t.split(/[- :]/);
    // Apply each element to the Date function and return
    return new Date(t[0], t[1]-1, t[2]);
  }
  import settings from "../../settings";
  import axios from 'axios';
  import Datepicker from 'vuejs-datepicker';
  var API_URL = settings.API_URL + "infotechnic/";
  var today = new Date();
  var today = new Date (today.getFullYear(), today.getMonth(), today.getDate());
  var monthFirst = new Date (today.getFullYear(), today.getMonth(), 1);
  export default {
    name: 'ITUsage',
    components: {
      Datepicker
    },
    data () {
      return {
        loading:true,
        overview: {},
        logs: {},
        dateFrom: monthFirst,
        dateTo: today,
      }
    },
    computed:{

    },
    methods:{
      getUsage() {
        axios.get(API_URL + 'usage.php')
                .then((response) => {
                  this.overviews = response.data.overview;
                  this.logs = response.data.log;
                  this.loading = false;
                });
      }

    },
    mounted(){
      this.getUsage();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>